export const setEntityInFocusStatus = (state, payload) => {
    state.lastGDMUpdate = payload.lastPublishDate;
    state.publishStatus = payload.status;
};
export const setExportFinished = (state, payload) => {
    state.exportFinished = payload;
};
export const setImportInProgress = (state, payload) => {
    state.isImportInProgress = payload;
};
export const setEntitySelected = (state, payload) => {
    state.entitySelected = payload;
};
